import { Component, Input, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import * as _moment from 'moment';
import { CountdownModule } from '@fgb/portal-component-library/src/lib/shared/countdown';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';
import * as ɵngcc2 from '@fgb/portal-component-library/src/lib/shared/countdown';

function TicketTransferWindowStatusComponent_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelement(1, "div", 2);
    ɵngcc0.ɵɵelementStart(2, "p");
    ɵngcc0.ɵɵtext(3, "fgbcl.ticket.transfer.status.window.open.text");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(4, "fgbcl-countdown", 3);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵpropertyInterpolate("endDateTime", ctx_r0.windowEndDate);
} }
function TicketTransferWindowStatusComponent_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelement(1, "div", 2);
    ɵngcc0.ɵɵelementStart(2, "div", 4);
    ɵngcc0.ɵɵtext(3, "Ticket window ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "div", 5);
    ɵngcc0.ɵɵtext(5, "fgbcl.ticket.transfer.status.closed.text");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} }
function TicketTransferWindowStatusComponent_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelement(1, "div", 2);
    ɵngcc0.ɵɵelementStart(2, "div", 4);
    ɵngcc0.ɵɵtext(3, "Ticket window ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "div", 5);
    ɵngcc0.ɵɵtext(5, "fgbcl.ticket.transfer.status.not.open.text");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} }
const _c0 = function (a0) { return { closed: a0 }; };
const moment = _moment;
class TicketTransferWindowStatusComponent {
    constructor() {
        this.transferWindowClosed = false;
        this.transferWindowNotOpen = false;
    }
    ngOnInit() {
        this.transferWindowClosed = moment.utc(this.windowEndDate).isBefore(moment.utc());
        this.transferWindowNotOpen = moment.utc(this.windowStartDate).isAfter(moment.utc());
    }
}
TicketTransferWindowStatusComponent.ɵfac = function TicketTransferWindowStatusComponent_Factory(t) { return new (t || TicketTransferWindowStatusComponent)(); };
TicketTransferWindowStatusComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: TicketTransferWindowStatusComponent, selectors: [["fgbcl-ticket-transfer-window-status"]], inputs: { windowStartDate: "windowStartDate", windowEndDate: "windowEndDate" }, decls: 5, vars: 6, consts: [[1, "card", "text-center", "ticket-transfer-window-status", "p-4", 3, "ngClass"], [4, "ngIf"], [1, "icon-timer-1", "ticket-transfer-window-status-icon", "mb-3"], [3, "endDateTime"], [1, "ticket-window-text"], [1, "ticket-window-closed-text"]], template: function TicketTransferWindowStatusComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵtemplate(1, TicketTransferWindowStatusComponent_ng_container_1_Template, 5, 1, "ng-container", 1);
        ɵngcc0.ɵɵelementStart(2, "div");
        ɵngcc0.ɵɵtemplate(3, TicketTransferWindowStatusComponent_ng_container_3_Template, 6, 0, "ng-container", 1);
        ɵngcc0.ɵɵtemplate(4, TicketTransferWindowStatusComponent_ng_container_4_Template, 6, 0, "ng-container", 1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(4, _c0, ctx.transferWindowNotOpen));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.transferWindowClosed && !ctx.transferWindowNotOpen);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.transferWindowClosed);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.transferWindowNotOpen);
    } }, directives: [ɵngcc1.NgClass, ɵngcc1.NgIf, ɵngcc2.CountdownComponent], styles: [""] });
TicketTransferWindowStatusComponent.ctorParameters = () => [];
TicketTransferWindowStatusComponent.propDecorators = {
    windowStartDate: [{ type: Input }],
    windowEndDate: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TicketTransferWindowStatusComponent, [{
        type: Component,
        args: [{
                selector: 'fgbcl-ticket-transfer-window-status',
                template: "<div class=\"card text-center ticket-transfer-window-status p-4\" [ngClass]=\"{ closed: transferWindowNotOpen }\">\r\n    <ng-container *ngIf=\"!transferWindowClosed && !transferWindowNotOpen\">\r\n      <div class=\"icon-timer-1 ticket-transfer-window-status-icon mb-3\"></div>\r\n      <p>fgbcl.ticket.transfer.status.window.open.text</p>\r\n      <fgbcl-countdown endDateTime=\"{{ windowEndDate }}\"></fgbcl-countdown>\r\n    </ng-container>\r\n    <div>\r\n      <ng-container *ngIf=\"transferWindowClosed\">\r\n        <div class=\"icon-timer-1 ticket-transfer-window-status-icon mb-3\"></div>\r\n          <div class=\"ticket-window-text\">Ticket window </div>\r\n          <div class=\"ticket-window-closed-text\">fgbcl.ticket.transfer.status.closed.text</div>\r\n        \r\n      </ng-container>\r\n      <ng-container *ngIf=\"transferWindowNotOpen\">\r\n        <div class=\"icon-timer-1 ticket-transfer-window-status-icon mb-3\"></div>\r\n          <div class=\"ticket-window-text\">Ticket window </div>\r\n          <div class=\"ticket-window-closed-text\">fgbcl.ticket.transfer.status.not.open.text</div>\r\n      </ng-container>\r\n    </div>\r\n  </div>",
                styles: [""]
            }]
    }], function () { return []; }, { windowStartDate: [{
            type: Input
        }], windowEndDate: [{
            type: Input
        }] }); })();

class TicketTransferWindowStatusModule {
}
TicketTransferWindowStatusModule.ɵfac = function TicketTransferWindowStatusModule_Factory(t) { return new (t || TicketTransferWindowStatusModule)(); };
TicketTransferWindowStatusModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: TicketTransferWindowStatusModule });
TicketTransferWindowStatusModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            CountdownModule,
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(TicketTransferWindowStatusModule, { declarations: function () { return [TicketTransferWindowStatusComponent]; }, imports: function () { return [CommonModule,
        CountdownModule]; }, exports: function () { return [TicketTransferWindowStatusComponent]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TicketTransferWindowStatusModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    TicketTransferWindowStatusComponent
                ],
                imports: [
                    CommonModule,
                    CountdownModule,
                ],
                exports: [
                    TicketTransferWindowStatusComponent
                ]
            }]
    }], null, null); })();

/**
 * Generated bundle index. Do not edit.
 */

export { TicketTransferWindowStatusComponent, TicketTransferWindowStatusModule };

//# sourceMappingURL=fgb-portal-component-library-src-lib-tickettransfer-ticket-transfer-window-status.js.map